export default function SupportAreaSection() {
  return (
    <section className="py-16 sm:py-24 lg:py-32 bg-gradient-to-b from-white to-[#FAF0E6]">
      <div className="max-w-6xl mx-auto px-4 sm:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#2C2C2C] mb-4">
            サポート範囲と条件
          </h2>
          <p className="text-base sm:text-lg text-[#757575] max-w-3xl mx-auto leading-relaxed">
            サポートは、落ち着いた環境で安心してご相談いただける場所にて行っています。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center mb-12 sm:mb-16">
          <div className="order-2 lg:order-1">
            <div className="space-y-6">
              <div className="bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-all">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center flex-shrink-0 bg-[#E8F5E9] rounded-xl">
                    <i className="ri-store-2-line text-2xl text-[#66BB6A]"></i>
                  </div>
                  <div>
                    <h3 className="text-lg sm:text-xl font-bold text-[#2C2C2C] mb-2">
                      店舗や事業所へお伺いしてのサポート
                    </h3>
                    <p className="text-sm sm:text-base text-[#757575] leading-relaxed">
                      慣れた環境で安心してご相談いただけます
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-all">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center flex-shrink-0 bg-[#E8F5E9] rounded-xl">
                    <i className="ri-home-office-line text-2xl text-[#66BB6A]"></i>
                  </div>
                  <div>
                    <h3 className="text-lg sm:text-xl font-bold text-[#2C2C2C] mb-2">
                      相談員の事務所での対面相談
                    </h3>
                    <p className="text-sm sm:text-base text-[#757575] leading-relaxed">
                      落ち着いた空間でじっくり学べます
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-all">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center flex-shrink-0 bg-[#E8F5E9] rounded-xl">
                    <i className="ri-restaurant-line text-2xl text-[#66BB6A]"></i>
                  </div>
                  <div>
                    <h3 className="text-lg sm:text-xl font-bold text-[#2C2C2C] mb-2">
                      知人の飲食店（閉店時）の静かなスペースでのサポート
                    </h3>
                    <p className="text-sm sm:text-base text-[#757575] leading-relaxed">
                      リラックスした雰囲気の中でご相談いただけます
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-[#E8F5E9] to-[#C8E6C9] rounded-2xl p-6 text-center">
                <p className="text-base sm:text-lg text-[#2C2C2C] font-medium">
                  ご希望に合わせて選べますので、<br className="hidden sm:block" />
                  無理のない形で学べます。
                </p>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="w-full h-80 sm:h-96 lg:h-[500px] rounded-3xl overflow-hidden shadow-xl">
              <img 
                alt="落ち着いた環境でのサポートのイメージ - 明るく清潔な相談スペースで、女性相談員が親身にサポートしている様子" 
                className="w-full h-full object-cover object-top" 
                src="https://static.readdy.ai/image/a94bf782443eac1605091ed034a69659/26007971caf115bc71ed16963683fd6d.jpeg"
              />
            </div>
          </div>
        </div>

        <div className="bg-white rounded-3xl p-8 sm:p-10 lg:p-12 shadow-xl">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            <div className="flex-shrink-0">
              <div className="w-20 h-20 sm:w-24 sm:h-24 bg-gradient-to-br from-[#66BB6A] to-[#4CAF50] rounded-2xl flex items-center justify-center shadow-lg">
                <i className="ri-map-pin-range-line text-4xl sm:text-5xl text-white"></i>
              </div>
            </div>
            
            <div className="flex-1 text-center lg:text-left space-y-4">
              <h3 className="text-2xl sm:text-3xl font-bold text-[#2C2C2C]">
                訪問対応エリア
              </h3>
              <p className="text-base sm:text-lg text-[#757575] leading-relaxed">
                訪問対応は<strong className="text-[#66BB6A] font-bold">相談員事務所から5km以内の店舗・事業者様を対象</strong>としています。
              </p>
              <p className="text-base sm:text-lg text-[#757575] leading-relaxed">
                範囲外の方には、オンラインでのご相談をご案内しております。
              </p>
            </div>

            <div className="flex-shrink-0">
              <div className="bg-[#E8F5E9] rounded-2xl p-6 text-center">
                <div className="text-4xl sm:text-5xl font-bold text-[#66BB6A] mb-2">5km</div>
                <div className="text-sm sm:text-base text-[#757575] font-medium">訪問可能範囲</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
